import { NUM_LEVEL } from '../../../constants/layout';
import { HEADER_HEIGHT } from '../NavigHeaderBar/NavigHeaderBarCss';
import TreePaneResizer from '../NavigTreeResizePane/TreePaneResizer';

export const NavigResizeBar = () => {
  return (
    <div
      style={{
        top: HEADER_HEIGHT,
        display: 'block',
        width: '100%',
        height: '20px',
        backgroundColor: 'var(--ds-bg-secondary)',
        border: '0px solid blue',
        position: 'relative',
      }}
    >
      {Array.from({ length: NUM_LEVEL }, (_, i) => (
        <TreePaneResizer level={i} />
      ))}
    </div>
  );
};
